


import React, { useState, useEffect, useCallback } from 'react';
import {Box,Tabs,Tab,Paper,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,TablePagination,Chip,IconButton,Dialog,DialogTitle,DialogContent,
  DialogActions,Button,TextField,Select,MenuItem,FormControl,InputLabel,Typography,Card,CardContent,Grid,Tooltip,Badge,CircularProgress,
  Alert,InputAdornment,FormControlLabel,Checkbox,Divider,Stack,alpha,
} from '@mui/material';
import { Visibility, Edit, GetApp, Search, Close, Send, CheckCircle, Error as ErrorIcon, Schedule, Email, Info, TrendingUp, Assessment, FilterList, Refresh,
} from '@mui/icons-material';
import CustomDialog from "../../CustomDialog";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import {fetchUserFromRedis} from "../AuthonticationPages/Register"
import { apiRequest } from "../../fetchSetup";
import axios from 'axios'

const ComplaintsDashboard = () => {
  // State Management
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [complaints, setComplaints] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedItem, setSelectedItem] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [responseDialogOpen, setResponseDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [updateStatus, setUpdateStatus] = useState('');
  const [responseText, setResponseText] = useState('');
  const [sendEmailNotification, setSendEmailNotification] = useState(true);
  const [dialog, setDialog] = useState({ open: false, message: '', title: '', type: 'info' });
  const [stats, setStats] = useState({
    totalComplaints: 0,
    openComplaints: 0,
    inProgressComplaints: 0,
    resolvedComplaints: 0,
    closedComplaints: 0,
    totalFeedback: 0,
    avgRating: 0,
  });
  const [sending, setSending] = useState(false);

  const [user, setUser] = useState(null);
  useEffect(() => {
    const loadUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        setLoading(false);
        return;
      }
      try {
        const data = await fetchUserFromRedis();
        setUser(data || null);
        if (data?.role) {
          sessionStorage.setItem("userrole", data.role);
        }
      } catch (error) {
        console.error("Failed to load user:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    loadUser();
  }, []);
  const userRole = user?.role || sessionStorage.getItem("userrole");
  

  // Determine theme color based on role
  const getThemeColor = () => {
    switch(userRole) {
      case 'medicineadmin':
        return '#006D77'; 
      case 'diagnosticadmin':
        return '#006D77';
      case 'admin':
      default:
        return '#006D77';
    }
  };

  const themeColor = getThemeColor();

  // Get dashboard title based on role
  const getDashboardTitle = () => {
    switch(userRole) {
      case 'medicineadmin':
        return 'Medicine Orders Complaints & Feedback';
      case 'diagnosticadmin':
        return 'Booking Complaints & Feedback';
      case 'admin':
      default:
        return 'Complaints & Feedback Management';
    }
  };

  const getDashboardSubtitle = () => {
    switch(userRole) {
      case 'medicineadmin':
        return 'Monitor and manage medicine order complaints and feedback';
      case 'diagnosticadmin':
        return 'Monitor and manage booking-related complaints and feedback';
      case 'admin':
      default:
        return 'Monitor and manage all customer complaints and feedback in real-time';
    }
  };

  // Filter data based on user role
  const filterDataByRole = (data, dataType = 'complaints') => {
    if (userRole === 'admin') {
      // Admin sees everything
      return data;
    } else if (userRole === 'medicineadmin') {
      // Medicine admin sees only medicine-related data
      if (dataType === 'complaints') {
        return data.filter(item => item.complaint_type === 'medicine');
      } else if (dataType === 'feedback') {
        return data.filter(item => 
          item.service_type?.toLowerCase().includes('medicine') ||
          item.service_type?.toLowerCase().includes('pharmacy') ||
          item.service_type?.toLowerCase().includes('order')
        );
      }
    } else if (userRole === 'diagnosticadmin') {
      // Diagnostic admin sees only booking-related data
      if (dataType === 'complaints') {
        return data.filter(item => !item.complaint_type || item.complaint_type === 'booking');
      } else if (dataType === 'feedback') {
        return data.filter(item => 
          item.service_type === 'booking' || 
          item.service_type === 'appointment' ||
          item.service_type === 'diagnostic' ||
          !item.service_type?.toLowerCase().includes('medicine')
        );
      }
    }
    return data;
  };

  // Fetch Data Functions
  const fetchComplaints = useCallback(async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_ALL_COMPLAINTS_API}`);
      if (!response.data) throw new Error('Failed to fetch complaints');
      
      const data = await response.data;
      console.log("All complaints data:", data);
      
      // Filter based on user role
      const filteredData = filterDataByRole(data, 'complaints');
      console.log(`Filtered complaints for ${userRole}:`, filteredData);
      
      setComplaints(filteredData);
    } catch (error) {
      console.error('Error fetching complaints:', error);
      showDialog('Failed to fetch complaints', 'Error', 'error');
    } finally {
      if (showLoader) setLoading(false);
      setRefreshing(false);
    }
  }, [userRole]);
  
  const fetchFeedback = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_COMPLAINT_FEEDBACK_API}/list?limit=100`);
      if (!response.data) throw new Error('Failed to fetch feedback');
      
      const data = await response.data;
      console.log("All feedback data:", data);
      
      // Filter based on user role
      const filteredData = filterDataByRole(data.feedback || [], 'feedback');
      console.log(`Filtered feedback for ${userRole}:`, filteredData);
      
      setFeedback(filteredData);
    } catch (error) {
      console.error('Error fetching feedback:', error);
      showDialog('Failed to fetch feedback', 'Warning', 'warning');
    }
  }, [userRole]);

  useEffect(() => {
    calculateStats(complaints, feedback);
  }, [complaints, feedback]);
  
  const handleRefresh = async () => {
    setRefreshing(true);
    await Promise.all([fetchComplaints(false), fetchFeedback()]);
    showDialog('Data refreshed successfully', 'Success', 'success');
  };

  // WebSocket Connection
  useEffect(() => {
    fetchComplaints();
    fetchFeedback();
    const token = sessionStorage.getItem("token");
    const ws = new WebSocket(`${process.env.REACT_APP_WS_COMPLAINTS}?token=${token}`
);
    
    ws.onopen = () => {
      console.log('WebSocket connected');
    };
    
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.event === 'complaint_created' || data.event === 'complaint_updated') {
        fetchComplaints(false);
        showDialog(`Complaint ${data.event === 'complaint_created' ? 'created' : 'updated'}`, 'Notification', 'info');
      }
    };
    
    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
    
    ws.onclose = () => {
      console.log('WebSocket disconnected');
    };
    
    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [fetchComplaints, fetchFeedback]);

  // Calculate Statistics
  const calculateStats = (complaintsData, feedbackData) => {
    const total = complaintsData.length;
    const open = complaintsData.filter(c => c.status === 'open').length;
    const inProgress = complaintsData.filter(c => c.status === 'in-progress').length;
    const resolved = complaintsData.filter(c => c.status === 'resolved').length;
    const closed = complaintsData.filter(c => c.status === 'closed').length;
    const totalFb = feedbackData.length;
    const avgRating = totalFb > 0 
      ? (feedbackData.reduce((sum, f) => sum + (f.rating || 0), 0) / totalFb).toFixed(1)
      : 0;

    setStats({
      totalComplaints: total,
      openComplaints: open,
      inProgressComplaints: inProgress,
      resolvedComplaints: resolved,
      closedComplaints: closed,
      totalFeedback: totalFb,
      avgRating,
    });
  };

  // Action Handlers
  const handleUpdateStatus = async () => {
    if (!updateStatus) {
      showDialog('Please select a status', 'Warning', 'warning');
      return;
    }

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_UPDATE_COMPLAINT_API}/${selectedItem.complaint_id}/status?status=${updateStatus}&send_email_notification=${sendEmailNotification}`,
        // { method: 'PATCH' }
      );
      
      if (!response.data) throw new Error('Failed to update status');
      
      const result = await response.data;
      
      const message = result.email_sent 
        ? `Status updated successfully.\nEmail sent to ${result.email_recipient}`
        : 'Status updated successfully';
      
      showDialog(message, 'Success', 'success');
      fetchComplaints(false);
      setUpdateDialogOpen(false);
      setUpdateStatus('');
    } catch (error) {
      console.error('Error updating status:', error);
      showDialog('Failed to update status', 'Error', 'error');
    }
  };

  const handleSendResponse = async () => {
    if (!responseText.trim()) {
      showDialog('Please enter a response message', 'Warning', 'warning');
      return;
    }
    setSending(true); 
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_GET_COMPLAINTS_API}/${selectedItem.complaint_id}/response`,
        {
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: responseText,
            admin_id: 'ADMIN001',
          }),
        }
      );
      if (!response.data) throw new Error('Failed to send response');
      
      const result = await response.data;
      
      const message = result.email_sent 
        ? `Response sent successfully to\n${result.email_recipient}`
        : 'Response processed but email could not be sent';
      
      showDialog(message, result.email_sent ? 'Success' : 'Warning', result.email_sent ? 'success' : 'warning');
      setResponseDialogOpen(false);
      setResponseText('');
    } catch (error) {
      console.error('Error sending response:', error);
      showDialog('Failed to send response', 'Error', 'error');
    }finally {
      setSending(false);   
    }
  };

  const exportToCSV = () => {
    const data = activeTab === 0 ? filteredComplaints : filteredFeedback;
    const timestamp = new Date().toISOString().split('T')[0];
    
    const headers = activeTab === 0 
      ? ['Complaint ID', 'Type', 'Category', 'Status', 'User', 'Email', 'Created At']
      : ['Feedback ID', 'Rating', 'Comment', 'Service', 'User', 'Email', 'Created At'];
    
    const csv = [
      headers.join(','),
      ...data.map(item => {
        if (activeTab === 0) {
          return [
            item.complaint_id,
            item.complaint_type || 'booking',
            item.category,
            item.status,
            item.booking?.name || item.medicine_order?.user_email || 'N/A',
            item.booking?.email || item.medicine_order?.user_email || 'N/A',
            item.created_at ? new Date(item.created_at).toLocaleDateString() : 'N/A',
          ].join(',');
        } else {
          return [
            item.feedback_id,
            item.rating,
            `"${(item.comment || '').replace(/"/g, '""')}"`,
            item.service_type,
            item.user_name,
            item.user_email,
            new Date(item.created_at).toLocaleDateString(),
          ].join(',');
        }
      })
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${userRole}_${activeTab === 0 ? 'complaints' : 'feedback'}_${timestamp}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    showDialog('CSV exported successfully', 'Success', 'success');
  };

  const showDialog = (message, title, type) => {
    setDialog({ open: true, message, title, type });
  };

  const getStatusColor = (status) => {
    const colors = {
      open: 'error',
      'in-progress': 'warning',
      resolved: 'success',
      closed: 'default',
    };
    return colors[status] || 'default';
  };

  const getStatusIcon = (status) => {
    const icons = {
      open: <ErrorIcon fontSize="small" />,
      'in-progress': <Schedule fontSize="small" />,
      resolved: <CheckCircle fontSize="small" />,
      closed: <CheckCircle fontSize="small" />,
    };
    return icons[status] || null;
  };

  // Filter Data
  const filteredComplaints = complaints.filter(c => {
    const matchesSearch = 
      c.complaint_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.booking?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.medicine_order?.user_email?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || c.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const filteredFeedback = feedback.filter(f => {
    return (
      f.feedback_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      f.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      f.comment?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const currentData = activeTab === 0 ? filteredComplaints : filteredFeedback;
  const paginatedData = currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Statistics Cards Component
  const StatCard = ({ title, value, icon, color, subtitle }) => (
    <Card 
      elevation={0}
      sx={{ 
        height: '100%',
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `1px solid ${color}30`,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: `0 8px 16px ${color}20`,
        }
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography color="textSecondary" variant="body2" fontWeight={500}>
            {title}
          </Typography>
          <Box sx={{ color, opacity: 0.7 }}>{icon}</Box>
        </Stack>
        <Typography variant="h3" fontWeight={700} sx={{ color, mb: 0.5 }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="textSecondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ minHeight: '100vh',justifyContent: "center",py: 6,px: 1,backgroundColor: "transparent", ml: {
      xs: 0,       // mobile
      sm: 0,       // small tablets
      md: "280px", // medium screens
      lg: "280px", // desktops
    }, }}>
      <Paper
       sx={{ width:{md:"95%",lg:"95%",xs:"95%",sm:"95%"}, 
        p: 3, 
 }}>
      <IconButton onClick={() => navigate(-1)} sx={{color: themeColor}}>
        <ArrowBack sx={{ fontSize: 32 }} /> 
      </IconButton>
      
      {/* Header */}
      <Box sx={{ bgcolor: 'white', borderBottom: '1px solid', borderColor: 'divider', mb: 3, p: 3 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Box>
            <Typography variant="h4" fontWeight="bold" color={themeColor} gutterBottom>
              {getDashboardTitle()}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {getDashboardSubtitle()}
            </Typography>
            <Chip 
              label={`Role: ${userRole}`}
              size="small"
              sx={{ 
                mt: 1, 
                bgcolor: alpha(themeColor, 0.1), 
                color: themeColor,
                fontWeight: 600 
              }}
            />
          </Box>

          <Tooltip title="Refresh Data">
            <IconButton 
              onClick={handleRefresh} 
              disabled={refreshing}
              sx={{ 
                bgcolor: themeColor, 
                color: 'white',
                '&:hover': { bgcolor: alpha(themeColor, 0.8) },
                '&:disabled': { bgcolor: 'grey.300' }
              }}
            >
              <Refresh className={refreshing ? 'rotating' : ''} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>

      <Box sx={{ px: 3 }}>
        {/* Statistics Cards */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={2.4}>
            <StatCard 
              title="Total Complaints" 
              value={stats.totalComplaints}
              icon={<Assessment />}
              color={themeColor}
              subtitle="All time"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <StatCard 
              title="Open" 
              value={stats.openComplaints}
              icon={<ErrorIcon />}
              color="#f44336"
              subtitle="Require attention"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <StatCard 
              title="In Progress" 
              value={stats.inProgressComplaints}
              icon={<Schedule />}
              color="#ff9800"
              subtitle="Being resolved"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <StatCard 
              title="Resolved" 
              value={stats.resolvedComplaints}
              icon={<CheckCircle />}
              color="#4caf50"
              subtitle="Completed"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4}>
            <StatCard 
              title="Feedback Rating" 
              value={`${stats.avgRating}/5`}
              icon={<TrendingUp />}
              color="#9c27b0"
              subtitle={`${stats.totalFeedback} reviews`}
            />
      
          </Grid>
        </Grid>

        {/* Main Content */}
        <Paper 
          elevation={0}
          sx={{ 
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider'
          }}
        >
          {/* Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
            <Tabs 
              value={activeTab} 
              onChange={(e, v) => {
                setActiveTab(v);
                setPage(0);
                setSearchTerm('');
                setStatusFilter('all');
              }}
              TabIndicatorProps={{sx: { backgroundColor: themeColor }}}
              sx={{ 
                '& .MuiTab-root': {color: themeColor, textTransform: 'none', fontSize: '16px'},
                '& .Mui-selected': {color: `${themeColor} !important`,fontWeight: 'bold'},
              }}
            >
              <Tab 
                label={
                  <Badge 
                    badgeContent={stats.openComplaints} 
                    color="error"
                    sx={{'& .MuiBadge-badge': { right: -6, top: 2 }}}
                  >
                    <Box sx={{ pr: 2 }}>Complaints</Box>
                  </Badge>
                } 
              />
              <Tab 
                label={
                  <Badge 
                    badgeContent={stats.totalFeedback} 
                    sx={{
                      '& .MuiBadge-badge': { 
                        right: -6, 
                        top: 2,
                        backgroundColor: themeColor,
                        color: 'white'
                      }
                    }}
                  >
                    <Box sx={{ pr: 2 }}>Feedback</Box>
                  </Badge>
                }
              />
            </Tabs>
          </Box>

          {/* Filters and Actions */}
          <Box sx={{ 
            p: 2.5, 
            bgcolor: alpha('#000', 0.02),
            display: 'flex', 
            gap: 2, 
            flexWrap: 'wrap',
            alignItems: 'center'
          }}>
            <TextField
              placeholder={`Search ${activeTab === 0 ? 'complaints' : 'feedback'}...`}
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search color="action" />
                  </InputAdornment>
                ),
              }}
              sx={{ 
                minWidth: 280,
                '& .MuiOutlinedInput-root': {
                  bgcolor: 'background.paper',
                }
              }}
            />
            
            {activeTab === 0 && (
              <FormControl 
                size="small" 
                sx={{ 
                  minWidth: 180,
                  '& .MuiOutlinedInput-root': {
                    bgcolor: 'background.paper',
                  }
                }}
              >
                <InputLabel>
                  <FilterList fontSize="small" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                  Status Filter
                </InputLabel>
                <Select
                  value={statusFilter}
                  label="Status Filter"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="open">Open</MenuItem>
                  <MenuItem value="in-progress">In Progress</MenuItem>
                  <MenuItem value="resolved">Resolved</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                </Select>
              </FormControl>
            )}

            <Box sx={{ flexGrow: 1 }} />

            <Chip 
              label={`${currentData.length} ${activeTab === 0 ? 'Complaints' : 'Feedback'}`}
              variant="outlined"
              sx={{ bgcolor: alpha(themeColor, 0.1), color: themeColor }}
            />

            <Button
              variant="contained"
              startIcon={<GetApp />}
              onClick={exportToCSV}
              disabled={currentData.length === 0}
              sx={{ 
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: 2,
                backgroundColor: themeColor,
                '&:hover': { backgroundColor: alpha(themeColor, 0.8) }
              }}
            >
              Export CSV
            </Button>
          </Box>

          <Divider />

          {/* Table */}
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
              <CircularProgress size={48} sx={{ color: themeColor }} />
            </Box>
          ) : (
            <>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {activeTab === 0 ? (
                        <>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Complaint ID</TableCell>
                          {userRole === 'admin' && <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Type</TableCell>}
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Category</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Status</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>User</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Phone</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Created At</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Actions</TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Feedback ID</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Rating</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Comment</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Service</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>User</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Phone</TableCell>
                          <TableCell sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Created At</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 700, bgcolor: alpha('#000', 0.02) }}>Actions</TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={userRole === 'admin' && activeTab === 0 ? 7 : 7} align="center">
                          <Box sx={{ py: 6 }}>
                            <Info sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
                            <Typography variant="h6" color="textSecondary">
                              No {activeTab === 0 ? 'complaints' : 'feedback'} found
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                              {searchTerm || statusFilter !== 'all' 
                                ? 'Try adjusting your filters' 
                                : `No ${activeTab === 0 ? 'complaints' : 'feedback'} available yet`
                              }
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      paginatedData.map((item) => (
                        <TableRow 
                          key={activeTab === 0 ? item.complaint_id : item.feedback_id} 
                          hover
                          sx={{ 
                            '&:hover': { bgcolor: alpha('#000', 0.02) },
                            transition: 'background-color 0.2s'
                          }}
                        >
                          {activeTab === 0 ? (
                            <>
                              <TableCell>
                                <Typography variant="body2" fontWeight={600} color={themeColor}>
                                  {item.complaint_id}
                                </Typography>
                              </TableCell>
                              {userRole === 'admin' && (
                                <TableCell>
                                  <Chip 
                                    label={item.complaint_type || 'booking'} 
                                    size="small"
                                    color={item.complaint_type === 'medicine' ? 'secondary' : 'primary'}
                                    sx={{ fontWeight: 600, fontSize: '0.75rem' }}
                                  />
                                </TableCell>
                              )}
                              <TableCell>
                                <Typography variant="body2" noWrap sx={{ maxWidth: 180 }}>
                                  {item.category}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Chip
                                  label={item.status?.toUpperCase()}
                                  color={getStatusColor(item.status)}
                                  size="small"
                                  sx={{ fontWeight: 600, fontSize: '0.7rem', minWidth: 110 }}
                                />
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight={500}>
                                  {item.booking?.name || item.medicine_order?.user_name || 'N/A'}
                                </Typography>
                              </TableCell>
                              <TableCell>
                              <Typography variant="body2" fontWeight={500}>
                                {item.booking?.phone || item.medicine_order?.user_phone ||'N/A'}
                              </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" color="textSecondary">
                                  {item.created_at ? new Date(item.created_at).toLocaleDateString() : 'N/A'}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Stack direction="row" spacing={0.5} justifyContent="center">
                                  <Tooltip title="View Details" arrow>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedItem(item);
                                        setViewDialogOpen(true);
                                      }}
                                      sx={{ '&:hover': { bgcolor: alpha(themeColor, 0.1) } }}
                        >
                        <Visibility fontSize="small" />
                          </IconButton>
                            </Tooltip>
                            <Tooltip title="Update Status" arrow>
                          <IconButton
                            size="small"
                            onClick={() => {
                            setSelectedItem(item);
                            setUpdateStatus(item.status);
                            setUpdateDialogOpen(true);
                            }}
                            sx={{
                            color: 'warning.main',
                            '&:hover': { bgcolor: alpha('#ff9800', 0.1) }
                            }}
                           >
                        <Edit fontSize="small" />
                        </IconButton>
                          </Tooltip>
                          <Tooltip title="Send Email Response" arrow>
                        <IconButton
                          size="small"
                          onClick={() => {
                          setSelectedItem(item);
                          setResponseDialogOpen(true);
                          }}
                          sx={{
                          color: 'success.main',
                          '&:hover': { bgcolor: alpha('#4caf50', 0.1) }
                          }}
                        >
                        <Email fontSize="small" />
                        </IconButton>
                        </Tooltip>
                        </Stack>
                        </TableCell>
                        </>
                        ) : (
                        <>
                        <TableCell>
                        <Typography variant="body2" fontWeight={600} color={themeColor}>
                        {item.feedback_id}
                        </Typography>
                        </TableCell>
                        <TableCell>
                           <Chip 
                             label={`⭐ ${item.rating}/5`} 
                             color={item.rating >= 4 ? 'success' : item.rating >= 3 ? 'warning' : 'error'}
                             size="small"
                             sx={{ fontWeight: 600 }}
                           />
                        </TableCell>
                        <TableCell sx={{ maxWidth: 300 }}>
                        <Typography variant="body2" noWrap>
                            {item.comment?.substring(0, 60)}
                            {item.comment?.length > 60 && '...'}
                        </Typography>
                        </TableCell>
                        <TableCell>
                           <Typography variant="body2">{item.service_type}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight={500}>
                           {item.user_name}
                        </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight={500}>
                           {item.user_phone}
                        </Typography>
                        </TableCell>
                        <TableCell>
                        <Typography variant="body2" color="textSecondary">
                          {new Date(item.created_at).toLocaleDateString()}
                        </Typography>
                        </TableCell>
                        <TableCell align="center">
                           <Tooltip title="View Details" arrow>
                        <IconButton
                          size="small"
                          onClick={() => {
                          setSelectedItem(item);
                          setViewDialogOpen(true);
                          }}
                          sx={{
                          color: themeColor,
                          '&:hover': { bgcolor: alpha(themeColor, 0.1) }
                          }}
                        >
                        <Visibility fontSize="small" />
                          </IconButton>
                          </Tooltip>
                        </TableCell>
                        </>
                        )}
                        </TableRow>
                        ))
                        )}
                        </TableBody>
                        </Table>
                        </TableContainer>


                        <Divider />

                <TablePagination
                  component="div"
                  count={currentData.length}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  sx={{ bgcolor: alpha('#000', 0.01) }}
                />
                </>
                )}
                </Paper>
                </Box>

                {/* View Dialog */}
                <Dialog 
                open={viewDialogOpen} 
                onClose={() => setViewDialogOpen(false)} 
                maxWidth="md" 
                fullWidth
                PaperProps={{
                sx: { borderRadius: 2 }
                }}
                >
                <DialogTitle sx={{ 
                borderBottom: 1, 
                borderColor: 'divider',
                bgcolor: alpha(themeColor, 0.05),
                fontWeight: 700,
                color: themeColor
                }}>
                {activeTab === 0 ? 'Complaint Details' : 'Feedback Details'}
                <IconButton
                onClick={() => setViewDialogOpen(false)}
                sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                <Close />
                </IconButton>
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                {selectedItem && (
                <Box>
                {activeTab === 0 ? (
                  <Stack spacing={2.5}>
                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        COMPLAINT ID
                      </Typography>
                      <Typography variant="h6" fontWeight={700} color={themeColor}>
                        {selectedItem.complaint_id}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        TYPE & CATEGORY
                      </Typography>
                      <Stack direction="row" spacing={1} mt={0.5}>
                        <Chip 
                          label={selectedItem.complaint_type || 'booking'} 
                          size="small"
                          color={selectedItem.complaint_type === 'medicine' ? 'secondary' : 'primary'}
                        />
                        <Chip 
                          label={selectedItem.category} 
                          size="small"
                          variant="outlined"
                        />
                      </Stack>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        STATUS
                      </Typography>
                      <Box mt={0.5}>
                        <Chip
                          icon={getStatusIcon(selectedItem.status)}
                          label={selectedItem.status?.toUpperCase()}
                          color={getStatusColor(selectedItem.status)}
                          sx={{ fontWeight: 600 }}
                        />
                      </Box>
                    </Box>
                    {selectedItem.booking?.diagnostic_tests && (
                        <Box mt={1}>
                          <Typography variant="body2" fontWeight={600} color="textSecondary">
                            Diagnostic Tests
                          </Typography>
                          <Paper variant="outlined" sx={{ p: 1.5, mt: 0.5, bgcolor: alpha('#1976d2', 0.05), borderRadius: 1.5 }}>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                              {selectedItem.booking.diagnostic_tests}
                            </Typography>
                          </Paper>
                        </Box>
                      )}
                     

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        DESCRIPTION
                      </Typography>
                      <Paper 
                        variant="outlined" 
                        sx={{ 
                          p: 2, 
                          mt: 1, 
                          bgcolor: alpha('#000', 0.02),
                          borderRadius: 1.5
                        }}
                      >
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                          {selectedItem.description || selectedItem.feedback?.comment || 'No description provided'}
                        </Typography>
                      </Paper>
                    </Box>

                    {selectedItem.booking && (
                      <Box>
                        <Typography variant="caption" color="textSecondary" fontWeight={600}>
                          BOOKING DETAILS
                        </Typography>
                        <Paper variant="outlined" sx={{p: 2,mt: 1,bgcolor: alpha('#4caf50', 0.05),borderRadius: 1.5}}>
                        <Box display="flex" flexDirection="column" gap={0.8}>
                        <Box display="flex">
                        <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Booking ID</Typography>
                        <Typography variant="body2" >{selectedItem.booking.booking_id}</Typography>
                        </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}> Service :</Typography>
                            <Typography variant="body2" >{selectedItem.booking.service_type}</Typography>
                          </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Name :</Typography>
                            <Typography variant="body2">{selectedItem.booking.name} </Typography>
                          </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Email :</Typography>
                            <Typography variant="body2" >{selectedItem.booking.email || 'N/A'}</Typography>
                          </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Mobile :</Typography>
                            <Typography variant="body2" >{selectedItem.booking.phone || 'N/A'}</Typography>
                          </Box>

                        </Box>
                      </Paper>




                      </Box>
                    )}

                    {selectedItem.medicine_order && (
                      <Box>
                        <Typography variant="caption" color="textSecondary" fontWeight={600}>
                          ORDER DETAILS
                        </Typography>

                      <Paper variant="outlined" sx={{p: 2,mt: 1,bgcolor: alpha('#4caf50', 0.05),borderRadius: 1.5}}>
                        <Box display="flex" flexDirection="column" gap={0.8}>
                        <Box display="flex">
                        <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Order ID</Typography>
                        <Typography variant="body2" >{selectedItem.medicine_order.order_id}</Typography>
                        </Box>

                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}> Service :</Typography>
                            <Typography variant="body2" >{selectedItem.medicine_order.order_type}</Typography>
                          </Box>

                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}> Amount : </Typography>
                            <Typography variant="body2" >₹{selectedItem.medicine_order.total_amount}</Typography>
                          </Box>

                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Email :</Typography>
                         
                            <Typography variant="body2" >{selectedItem.medicine_order.user_email}</Typography>
                          </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Mobile :</Typography>
                            <Typography variant="body2"> {selectedItem.medicine_order.user_phone} </Typography>
                          </Box>
                        </Box>
                      </Paper>
                      </Box>
                    )}
                  {selectedItem.medicine_order?.items?.length > 0 && (
                    <Box mt={1}>
                      <Typography variant="body2" fontWeight={600} color="textSecondary">
                        Medicines
                      </Typography>
                      <Paper variant="outlined" sx={{ p: 1.5, mt: 0.5, bgcolor: alpha('#4caf50', 0.05), borderRadius: 1.5 }}>

                        <Stack spacing={0.5}>
                            {selectedItem.medicine_order.items.map((item, index) => (
                              <Box key={index} display="flex" justifyContent="space-between">
                                <Typography variant="body2">
                                  {item.medicine_name} × {item.quantity}
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  ₹{item.total_price}
                                </Typography>
                              </Box>
                            ))}

                            {/* Total row */}
                            <Box display="flex" justifyContent="space-between" mt={1} pt={1} borderTop={1} borderColor="divider">
                              <Typography variant="body2" fontWeight={600}>
                              Amount Paid 
                              </Typography>
                              <Typography variant="body2" fontWeight={600}>
                                ₹{selectedItem.medicine_order.total_amount}
                              </Typography>
                            </Box>
                          </Stack>

                      </Paper>
                    </Box>
                  )}

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        TIMESTAMP
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        Created: {selectedItem.created_at ? new Date(selectedItem.created_at).toLocaleString() : 'N/A'}
                      </Typography>
                      {selectedItem.updated_at && (
                        <Typography variant="body2" color="textSecondary">
                          Updated: {new Date(selectedItem.updated_at).toLocaleString()}
                        </Typography>
                      )}
                    </Box>
                  </Stack>
                ) : (
                  <Stack spacing={2.5}>
                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        FEEDBACK ID
                      </Typography>
                      <Typography variant="h6" fontWeight={700} color={themeColor}>
                        {selectedItem.feedback_id}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        RATING
                      </Typography>
                      <Box mt={0.5}>
                        <Chip 
                          label={`⭐ ${selectedItem.rating}/5`} 
                          color={selectedItem.rating >= 4 ? 'success' : selectedItem.rating >= 3 ? 'warning' : 'error'}
                          sx={{ fontWeight: 600, fontSize: '0.9rem' }}
                        />
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        COMMENT
                      </Typography>
                      <Paper 
                        variant="outlined" 
                        sx={{ 
                          p: 2, 
                          mt: 1, 
                          bgcolor: alpha('#000', 0.02),
                          borderRadius: 1.5
                        }}
                      >
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                          {selectedItem.comment}
                        </Typography>
                      </Paper>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        SERVICE & USER
                      </Typography>



                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mt: 1,
                          bgcolor: alpha('#4caf50', 0.05),
                          borderRadius: 1.5
                        }}
                      >
                        <Box display="flex" flexDirection="column" gap={0.8}>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}> Service :</Typography>
                            <Typography variant="body2">{selectedItem.service_type}</Typography>
                          </Box>

                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}> Name : </Typography>
                            <Typography variant="body2"> {selectedItem.user_name} </Typography>
                          </Box>

                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Email :</Typography>
                            <Typography variant="body2"> {selectedItem.user_email} </Typography>
                          </Box>
                          <Box display="flex">
                            <Typography variant="body2" sx={{ width: 90, fontWeight: 600 }}>Mobile :</Typography>
                            <Typography variant="body2"> {selectedItem.user_phone} </Typography>
                          </Box>
                        </Box>
                      </Paper>


                    </Box>

                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight={600}>
                        TIMESTAMP
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {new Date(selectedItem.created_at).toLocaleString()}
                      </Typography>
                    </Box>
                  </Stack>
                )}
                </Box>
                )}
                </DialogContent>
<DialogActions sx={{ p: 2.5, borderTop: 1, borderColor: 'divider' }}>
<Button onClick={() => setViewDialogOpen(false)} variant="outlined">
Close
</Button>
</DialogActions>
</Dialog>

{/* Update Status Dialog */}
<Dialog 
open={updateDialogOpen} 
onClose={() => setUpdateDialogOpen(false)}
PaperProps={{ sx: { borderRadius: 2, minWidth: 500 } }}
>
<DialogTitle sx={{ 
borderBottom: 1, 
borderColor: 'divider',
bgcolor: alpha('#ff9800', 0.05),
fontWeight: 700
}}>
Update Complaint Status
</DialogTitle>
<DialogContent sx={{ mt: 2.5 }}>
<Stack spacing={2.5}>
<Alert severity="info" variant="outlined">
Updating status for complaint: <strong>{selectedItem?.complaint_id}</strong>
</Alert>

<FormControl fullWidth>
<InputLabel>Status *</InputLabel>
<Select
  value={updateStatus}
  label="Status *"
  onChange={(e) => setUpdateStatus(e.target.value)}
>
  <MenuItem value="open">🔴 Open</MenuItem>
  <MenuItem value="in-progress">🟡 In Progress</MenuItem>
  <MenuItem value="resolved">✅ Resolved</MenuItem>
  <MenuItem value="closed">⚪ Closed</MenuItem>
</Select>
</FormControl>

<FormControlLabel
control={
  <Checkbox
    checked={sendEmailNotification}
    onChange={(e) => setSendEmailNotification(e.target.checked)}
    color="primary"
  />
}
label={
  <Box>
    <Typography variant="body2" fontWeight={600}>
      Send email notification to customer
    </Typography>
    <Typography variant="caption" color="textSecondary">
      User will receive status update via email
    </Typography>
  </Box>
}
/>
</Stack>
</DialogContent>
<DialogActions sx={{ p: 2.5, borderTop: 1, borderColor: 'divider' }}>
<Button onClick={() => setUpdateDialogOpen(false)} sx={{textTransform:"none"}}>
Cancel
</Button>
<Button 
onClick={handleUpdateStatus} 
variant="contained"
sx={{textTransform:"none",backgroundColor:themeColor,color:"white"}}
disabled={!updateStatus}
>
Update Status
</Button>
</DialogActions>
</Dialog>

{/* Response Dialog */}
<Dialog 
open={responseDialogOpen} 
onClose={() => setResponseDialogOpen(false)} 
maxWidth="sm" 
fullWidth
PaperProps={{ sx: { borderRadius: 2 } }}
>
<DialogTitle sx={{ 
borderBottom: 1, 
borderColor: 'divider',
bgcolor: alpha('#4caf50', 0.05),
fontWeight: 700
}}>
Send Email Response
<IconButton
onClick={() => setResponseDialogOpen(false)}
sx={{ position: 'absolute', right: 8, top: 8 }}
>
<Close />
</IconButton>
</DialogTitle>
<DialogContent sx={{ mt: 2 }}>
<Stack spacing={2}>
{selectedItem && (
<Alert severity="info" variant="outlined">
  <Typography variant="body2">
    Email will be sent to: <strong>{
      selectedItem.booking?.email || 
      selectedItem.medicine_order?.user_email || 
      'Email address not available'
    }</strong>
  </Typography>
</Alert>
)}
<TextField
fullWidth
multiline
rows={8}
label="Response Message *"
value={responseText}
onChange={(e) => setResponseText(e.target.value)}
placeholder="Type your detailed response to the customer here. Be professional, empathetic, and clear..."
helperText={`${responseText.length} characters`}
/>
</Stack>
</DialogContent>
<DialogActions sx={{ p: 2.5, borderTop: 1, borderColor: 'divider' }}>
<Button onClick={() => setResponseDialogOpen(false)} sx={{textTransform:"none"}}>
Cancel
</Button>
<Button 
  onClick={handleSendResponse}
  variant="contained"
  sx={{ textTransform:"none", backgroundColor: themeColor, color:"white" }}
  disabled={!responseText.trim() || sending}
>
  {sending ? (
    <CircularProgress size={22} sx={{ color: "white" }} />
  ) : (
    "Send Email"
  )}
</Button>

</DialogActions>
</Dialog>

{/* Custom Dialog (replacing Snackbar) */}
<CustomDialog
open={dialog.open}
message={dialog.message}
title={dialog.title}
type={dialog.type}
onClose={() => setDialog({ ...dialog, open: false })}
buttonText="OK"
/>

{/* CSS for rotating animation */}
<style jsx>{`
@keyframes rotate {
from {
transform: rotate(0deg);
}
to {
transform: rotate(360deg);
}
}
.rotating {
animation: rotate 1s linear infinite;
}
`}</style>
</Paper>
    </Box>
  );
};
export default ComplaintsDashboard;